<app-header-navigation-bar></app-header-navigation-bar>

<div class="detail-page">

    <section class="hero">
        <div class="hero-inner">
            <a class="hero-back" (click)="goBack()" role="button" tabindex="0">&lt; Volver</a>
            <h1 class="hero-title">Detalle del expediente</h1>
        </div>
    </section>

    <main class="detail-main">

        <div *ngIf="loadingEvent" class="detail-loading">
            <p>Cargando<span>.</span><span>.</span><span>.</span></p>
        </div>

        <ng-container *ngIf="event">

            <!-- Tabs -->
            <div class="tab-list" role="tablist">
                <button type="button" class="tab-item"
                        [class.tab-item--active]="selectedTab === 'detail'"
                        (click)="selectTab('detail')">
                    Detalle del expediente
                </button>
                <button type="button" class="tab-item"
                        [class.tab-item--active]="selectedTab === 'messenger'"
                        (click)="selectTab('messenger')">
                    Comunicación con el tramitador
                </button>
            </div>

            <ng-container *ngIf="selectedTab === 'detail'">

                <!-- Estado actual -->
                <h2 class="section-title progress-title">Estado actual</h2>

                <!-- Progress bar 3 pasos -->
                <div class="progress-bar">
                    <div class="progress-step"
                         [class.progress-step--active]="isStepActive(1)"
                         [class.progress-step--done]="isStepDone(1)">
                        <div class="progress-track">
                            <div class="progress-fill"></div>
                        </div>
                        <div class="progress-text">
                            <p class="progress-label">Pendiente de referencia</p>
                            <p class="progress-date" *ngIf="stepDate(1)">{{ stepDate(1) | date: 'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                    <div class="progress-step"
                         [class.progress-step--active]="isStepActive(2)"
                         [class.progress-step--done]="isStepDone(2)">
                        <div class="progress-track">
                            <div class="progress-fill"></div>
                        </div>
                        <div class="progress-text">
                            <p class="progress-label">En trámite</p>
                            <p class="progress-date" *ngIf="stepDate(2)">{{ stepDate(2) | date: 'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                    <div class="progress-step"
                         [class.progress-step--active]="isStepActive(3)"
                         [class.progress-step--done]="isStepDone(3)">
                        <div class="progress-track">
                            <div class="progress-fill"></div>
                        </div>
                        <div class="progress-text">
                            <p class="progress-label">Cerrado</p>
                            <p class="progress-date" *ngIf="stepDate(3)">{{ stepDate(3) | date: 'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                </div>

                <!-- Datos del expediente -->
                <section class="detail-section">
                    <h2 class="section-title">Datos del expediente</h2>
                    <div class="datos-card">
                        <span class="datos-icon" aria-hidden="true">
                            <svg viewBox="0 0 32 32" fill="none" stroke="#00558c"
                                 stroke-width="2" stroke-linejoin="round" stroke-linecap="round">
                                <path d="M4 9a2 2 0 0 1 2-2h6l2 3h12a2 2 0 0 1 2 2v3H4V9z"/>
                                <path d="M4 15h24l-2 9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L4 15z"/>
                            </svg>
                        </span>
                        <div class="datos-grid">
                            <div class="datos-col">
                                <div class="datos-field">
                                    <span class="label">Nº Póliza / Contrato:</span>
                                    <span class="value">{{ event.policyNumber || event.idRea }}</span>
                                </div>
                                <div class="datos-field">
                                    <span class="label">Referencia:</span>
                                    <span class="value">{{ event.eventNumber }}</span>
                                </div>
                            </div>
                            <div class="datos-col">
                                <div class="datos-field">
                                    <span class="label">Producto:</span>
                                    <span class="value">{{ event.policyProduct }}</span>
                                </div>
                                <div class="datos-field">
                                    <span class="label">Versión:</span>
                                    <span class="value">{{ event.version }}</span>
                                </div>
                            </div>
                            <div class="datos-col">
                                <div class="datos-field">
                                    <span class="label">Fecha declaración:</span>
                                    <span class="value">{{ event.eventStartDate | date: 'dd/MM/yyyy' }}</span>
                                </div>
                                <div class="datos-field">
                                    <span class="label">Fecha de los hechos:</span>
                                    <span class="value">{{ event.eventEndDate | date: 'dd/MM/yyyy' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Coberturas y capitales -->
                <section class="detail-section" *ngIf="event.coverage && event.coverage.length > 0">
                    <h2 class="section-title">Coberturas y capitales asegurados</h2>
                    <div class="coberturas-card">
                        <div class="cobertura-row" *ngFor="let c of event.coverage">
                            <div class="cobertura-desc">
                                <span class="label">Cobertura:</span>
                                <span class="value">{{ c.description }}</span>
                            </div>
                            <div class="cobertura-field">
                                <span class="label">Capital:</span>
                                <span class="value">{{ c.capital | amountNoDecimals }}</span>
                            </div>
                            <div class="cobertura-field">
                                <span class="label">Capital libre elección:</span>
                                <span class="value">{{ c.capitalFree | amountNoDecimals }}</span>
                            </div>
                            <div class="cobertura-field">
                                <span class="label">Carencia:</span>
                                <span class="value">{{ c.carencia }} meses</span>
                            </div>
                            <div class="cobertura-field">
                                <span class="label">Franquicia:</span>
                                <span class="value">{{ (c.franquicia | amountNoDecimals) || 'Ninguna'}}</span>
                            </div>
                            <div class="cobertura-field">
                                <span class="label">Mínimo litigioso:</span>
                                <span class="value">{{ c.minLitigioso | amountNoDecimals }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Garantías implicadas -->
                <section class="detail-section" *ngIf="event.expedientEvent && event.expedientEvent.length > 0">
                    <h2 class="section-title">Garantías implicadas</h2>
                    <div class="garantias-card">
                        <table class="garantias-table">
                            <thead>
                                <tr>
                                    <th>Referencia</th>
                                    <th>Garantía</th>
                                    <th>Tramitador</th>
                                    <th>Situación</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- data-label: en movil la tabla se apila y cada celda muestra su cabecera
                                     como etiqueta (ver .garantias-table en el SCSS). -->
                                <tr *ngFor="let g of event.expedientEvent">
                                    <td data-label="Referencia">{{ g.expedientNumber }}</td>
                                    <td data-label="Garantía">{{ g.expedientType }}</td>
                                    <td data-label="Tramitador" class="tramitador">{{ g.expedientAgent }}</td>
                                    <td data-label="Situación">
                                        <span class="situacion-celda">
                                            <span class="badge" [ngClass]="badgeClass(g.expedientSituation)">
                                                {{ g.expedientSituation }}
                                            </span>
                                            <!-- SITUACION es el texto corto del badge y SITULARGA su descripcion
                                                 ampliada, que Innova no siempre informa: de ahi el *ngIf. -->
                                            <app-tooltip *ngIf="g.expedientSituationLarga"
                                                         direction="top" textAling="directionLeft"
                                                         text="{{ g.expedientSituationLarga }}"></app-tooltip>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <!-- Detalle del parte (acordeones) -->
                <section class="detail-section">
                    <h2 class="section-title">Detalle del expediente</h2>
                    <div class="accordion-list">

                        <div class="accordion" [class.accordion--open]="accordions.pagos">
                            <header class="accordion-head" (click)="toggleAccordion('pagos')">
                                <p class="accordion-title">Pagos relacionados con el expediente</p>
                                <span class="accordion-toggle"
                                      [class.accordion-toggle--open]="accordions.pagos"
                                      aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         stroke-width="2" stroke-linecap="round">
                                        <path d="M5 12h14"/>
                                        <path d="M12 5v14" *ngIf="!accordions.pagos"/>
                                    </svg>
                                </span>
                            </header>
                            <div class="accordion-body" *ngIf="accordions.pagos">
                                <app-pagos-parte [data]="event"></app-pagos-parte>
                            </div>
                        </div>

                        <div class="accordion" [class.accordion--open]="accordions.servicios">
                            <header class="accordion-head" (click)="toggleAccordion('servicios')">
                                <p class="accordion-title">Servicios relacionados con el expediente</p>
                                <span class="accordion-toggle"
                                      [class.accordion-toggle--open]="accordions.servicios"
                                      aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         stroke-width="2" stroke-linecap="round">
                                        <path d="M5 12h14"/>
                                        <path d="M12 5v14" *ngIf="!accordions.servicios"/>
                                    </svg>
                                </span>
                            </header>
                            <div class="accordion-body" *ngIf="accordions.servicios">
                                <app-servicios-relacionados-parte [data]="event"></app-servicios-relacionados-parte>
                            </div>
                        </div>

                        <div class="accordion" [class.accordion--open]="accordions.indemnizaciones">
                            <header class="accordion-head" (click)="toggleAccordion('indemnizaciones')">
                                <p class="accordion-title">Indemnizaciones relacionadas con el expediente</p>
                                <span class="accordion-toggle"
                                      [class.accordion-toggle--open]="accordions.indemnizaciones"
                                      aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         stroke-width="2" stroke-linecap="round">
                                        <path d="M5 12h14"/>
                                        <path d="M12 5v14" *ngIf="!accordions.indemnizaciones"/>
                                    </svg>
                                </span>
                            </header>
                            <div class="accordion-body" *ngIf="accordions.indemnizaciones">
                                <app-indemnizaciones-parte [data]="event"></app-indemnizaciones-parte>
                            </div>
                        </div>

                        <div class="accordion" [class.accordion--open]="accordions.comunicaciones">
                            <header class="accordion-head" (click)="toggleAccordion('comunicaciones')">
                                <p class="accordion-title">Consentimientos</p>
                                <span class="accordion-toggle"
                                      [class.accordion-toggle--open]="accordions.comunicaciones"
                                      aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         stroke-width="2" stroke-linecap="round">
                                        <path d="M5 12h14"/>
                                        <path d="M12 5v14" *ngIf="!accordions.comunicaciones"/>
                                    </svg>
                                </span>
                            </header>
                            <div class="accordion-body" *ngIf="accordions.comunicaciones">
                                <app-event-correspondence [data]="event"></app-event-correspondence>
                            </div>
                        </div>

                        <div class="accordion" [class.accordion--open]="accordions.documentos">
                            <header class="accordion-head" (click)="toggleAccordion('documentos')">
                                <p class="accordion-title">Documentos adjuntos</p>
                                <span class="accordion-toggle"
                                      [class.accordion-toggle--open]="accordions.documentos"
                                      aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         stroke-width="2" stroke-linecap="round">
                                        <path d="M5 12h14"/>
                                        <path d="M12 5v14" *ngIf="!accordions.documentos"/>
                                    </svg>
                                </span>
                            </header>
                            <div class="accordion-body" *ngIf="accordions.documentos">
                                <app-event-documentation [data]="event"></app-event-documentation>
                            </div>
                        </div>

                    </div>
                </section>

            </ng-container>

            <ng-container *ngIf="selectedTab === 'messenger'">
                <section class="messenger-wrapper">
                    <app-event-messenger [data]="event"
                                         *ngIf="event.expedientEvent && event.expedientEvent.length > 0">
                    </app-event-messenger>
                    <div *ngIf="!event.expedientEvent || event.expedientEvent.length === 0"
                         class="messenger-empty">
                        <p>No hay tramitador asignado todavía a este expediente.</p>
                    </div>
                </section>
            </ng-container>

        </ng-container>

    </main>

    <!-- NO abre el chat de Aunoa: irChat() navega
         al formulario de contacto (/contact/form).
    <button type="button" class="chat-fab" *ngIf="selectedTab !== 'messenger'"
            (click)="irChat()" aria-label="Abrir chat">
        <svg viewBox="0 0 24 24" fill="none" stroke="#ffffff"
             stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
        </svg>
    </button>
    -->

</div>

<app-footer></app-footer>
